// @ts-ignore - This is a workaround to fix the type error
import ReactRouterPrompt from "react-router-prompt";
import { ConfirmDialog } from "./ConfirmDialog";

type UnfinishedChangesPrompt = {
  when: boolean;
  header?: string;
  info?: string;
  confirmText?: string;
  minWidth?: string;
  maxWidth?: string;
};

export function UnfinishedChangesPrompt({
  when,
  header,
  info,
  confirmText,
  minWidth,
  maxWidth,
}: UnfinishedChangesPrompt) {
  return (
    <ReactRouterPrompt when={when}>
      {({
        isActive,
        onConfirm,
        onCancel,
      }: {
        isActive: boolean;
        onConfirm: () => void;
        onCancel: () => void;
      }) => (
        <ConfirmDialog
          open={isActive}
          onConfirm={onConfirm}
          onClose={onCancel}
          minWidth={minWidth}
          maxWidth={maxWidth}
          header={
            header ??
            "You have unsaved changes. Are you sure you want to leave?"
          }
          info={info}
          confirmText={confirmText ?? "Yes, I'm Sure"}
        />
      )}
    </ReactRouterPrompt>
  );
}
